import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import SubmitButton from "../../../../components/SubmitButton/SubmitButton";
import MyAccountContentHeader from "../MyAccountContentHeader/MyAccountContentHeader";
import "./MyAccountNewsletter.css";
import * as translator from '../../../../utils/translator';
import * as http from "../../../../utils/http";
import InnerHTMLRenderer from "../../../../components/InnerHTMLRenderer/InnerHTMLRenderer";
import Checkbox from "../../../../components/Checkbox/Checkbox";

const DEFAULT_SETTINGS = {
  email: { marketing: true },
  sms: { marketing: true, transactional: true },
  whatsapp: { marketing: true, transactional: true }
};

const ensureWhatsAppDefaults = (settings: any) => {
  if (!settings) return DEFAULT_SETTINGS;
  if (!settings.whatsapp) {
    settings.whatsapp = { marketing: true, transactional: true };
  }
  return settings;
};

const MyAccountNewsletter = () => {
  const { language, setActiveMenuLinkId, setStickyNotificationDetails, country, setError, setLoading } = useOutletContext<any>();
  const [newsletterSettings, setNewsletterSettings] = useState<any>(null);

  useEffect(() => {
    setActiveMenuLinkId("settings");
    setLoading(true);

		http
			.getFromServer(`${country}/account/newsletter`, [http.MIDDLEWARES.CUSTOMER_ID, http.MIDDLEWARES.CART_ORDER])
			.then((response) => {
				setNewsletterSettings(ensureWhatsAppDefaults(response.data || DEFAULT_SETTINGS));
			})
			.catch((error) => {
				window.clientLogger.error('Error in MyAccountNewsletter: ', error);
				setError(500);
			})
			.finally(() => {
				setLoading(false);
			});
  }, []);

  const onSubmit = () => {
    http
      .postToServer(`account-update/newsletter`,
        { registered: newsletterSettings },
        [http.MIDDLEWARES.CUSTOMER_ID]
      )
      .then((response) => {
        (window as any).eventsTracking.setData("opt_for_sendables", JSON.stringify(newsletterSettings), true);
        setStickyNotificationDetails((currentDetails: any) => ({
          show: true,
          title: "",
          content: translator.translate(language, "my_account", `stickyNotifications/success/Newsletter`),
          level: "info",
          showInfoIcon: false,
          refresh: !currentDetails.refresh
        }))
      })
      .catch((error) => {
        setStickyNotificationDetails((currentDetails: any) => ({
          show: true,
          title: "",
          content: translator.translate(language, "my_account", `stickyNotifications/error/error`),
          level: "error",
          showInfoIcon: false,
          refresh: !currentDetails.refresh
        }));
      })
  }

  const preSetRegistered = (type: string, category: string) => {
    const stateClone = newsletterSettings
    stateClone[type][category] = !newsletterSettings[type][category]
    setNewsletterSettings(stateClone)
  }


  if (!newsletterSettings) {
    return <></>
  }

  return (

    <>
      <div className="account-content">
        <MyAccountContentHeader
          title={translator.translate(language, "my_account", `Newsletter/title`)}
          description={translator.translate(language, "my_account", `Newsletter/subTitle`)}
        />

        <div className="newsletter-card">
          <p>{translator.translate(language, "my_account", `Newsletter/description`)}</p>
          <div className="sendable-box">
            <h5>{translator.translate(language, "my_account", `Newsletter/email/title`)}</h5>
            <h6>{translator.translate(language, "my_account", `Newsletter/type_subtitle`)}</h6>
            <Checkbox
              id={'optInMarketingEmails'}
              onClick={() => { preSetRegistered('email', 'marketing') }}
              label={translator.translate(language, "my_account", `Newsletter/email/marketing`)}
              value={newsletterSettings.email.marketing}
              groupName="optToNewsletter"
              errorMode={false}
              isChosenInCheckboxlist={newsletterSettings.email.marketing}
            />
          </div>
          <div className="sendable-box">
            <h5>{translator.translate(language, "my_account", `Newsletter/sms/title`)}</h5>
            <h6>{translator.translate(language, "my_account", `Newsletter/type_subtitle`)}</h6>
            <Checkbox
              id={'optInTrSMS'}
              onClick={() => { preSetRegistered('sms', 'transactional') }}
              label={translator.translate(language, "my_account", `Newsletter/sms/transactional`)}
              value={newsletterSettings.sms.transactional}
              groupName="optToNewsletter"
              errorMode={false}
              isChosenInCheckboxlist={newsletterSettings.sms.transactional}
            />
            <Checkbox
              id={'optInMarketingSMS'}
              onClick={() => { preSetRegistered('sms', 'marketing') }}
              label={translator.translate(language, "my_account", `Newsletter/sms/marketing`)}
              value={newsletterSettings.sms.marketing}
              groupName="optToNewsletter"
              errorMode={false}
              isChosenInCheckboxlist={newsletterSettings.sms.marketing}
            />
          </div>
          <div className="sendable-box">
            <h5>{translator.translate(language, "my_account", `Newsletter/whatsapp/title`)}</h5>
            <h6>{translator.translate(language, "my_account", `Newsletter/type_subtitle`)}</h6>
            <Checkbox
              id={'optInTrWhatsApp'}
              onClick={() => { preSetRegistered('whatsapp', 'transactional') }}
              label={translator.translate(language, "my_account", `Newsletter/whatsapp/transactional`)}
              value={newsletterSettings.whatsapp.transactional}
              groupName="optToNewsletter"
              errorMode={false}
              isChosenInCheckboxlist={newsletterSettings.whatsapp.transactional}
            />
            <Checkbox
              id={'optInMarketingWhatsApp'}
              onClick={() => { preSetRegistered('whatsapp', 'marketing') }}
              label={translator.translate(language, "my_account", `Newsletter/whatsapp/marketing`)}
              value={newsletterSettings.whatsapp.marketing}
              groupName="optToNewsletter"
              errorMode={false}
              isChosenInCheckboxlist={newsletterSettings.whatsapp.marketing}
            />
          </div>
          <p>{translator.translate(language, "my_account", `Newsletter/thank_you`)}</p>

          <SubmitButton
            id={"newsletter-submit"}
            placeholder={translator.translate(language, "my_account", `Newsletter/button`)}
            onSubmit={onSubmit}
          />
        </div>
        {country == 'fr' &&
          <div className="newsletter-disclaimer-card">
            <InnerHTMLRenderer htmlContent={translator.translate(language, "my_account", `Newsletter/disclaimer`)} />
          </div>
        }
      </div>
    </>
  )
};

export default MyAccountNewsletter;
